module.exports = __webpack_public_path__ + "img/project-5.e4a5f88b.jpg";